import { useEffect, useCallback } from 'react';
import { storage } from '@/utils/storage';
import { logoutService } from '@/utils/logoutService';

export const useStorageExpiry = () => {
  // Check expired items every 30 seconds for 2-minute expiry
  const checkExpiredItems = useCallback(async () => {
    console.log('Checking expired items...');
    const wasLoggedIn = storage.getLocal('auth_token') || storage.getSession('auth_token');
    console.log('Was logged in:', !!wasLoggedIn);
    
    storage.clearExpired();
    
    const stillLoggedIn = storage.getLocal('auth_token') || storage.getSession('auth_token');
    console.log('Still logged in after clear:', !!stillLoggedIn);
    
    // If user was logged in but token expired, auto logout
    if (wasLoggedIn && !stillLoggedIn) {
      console.log('Triggering auto logout!');
      await logoutService.autoLogout();
    }
  }, []);

  useEffect(() => {
    // Initial cleanup
    checkExpiredItems();

    // Set up interval to check every 30 seconds
    const interval = setInterval(checkExpiredItems, 60 * 1000);

    // Cleanup on page visibility change
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkExpiredItems();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [checkExpiredItems]);

  return {
    setLocal: storage.setLocal,
    getLocal: storage.getLocal,
    setSession: storage.setSession,
    getSession: storage.getSession,
    setCookie: storage.setCookie,
    getCookie: storage.getCookie,
    clearExpired: storage.clearExpired
  };
};